import { combineReducers } from 'redux';
import {
  fetchRequirementsAction,
  fetchRequirementsSuccessAction,
} from '../actions/requirements';
import { createReducer } from 'redux-create-reducer';

const requirementReducer = field => {
  return createReducer([], {
    [fetchRequirementsSuccessAction]: (state, action) => {
      return action.payload[field].filter(i => !i.deleted);
    },
  });
};

const annexReducer = field => {
  return createReducer(
    {},
    {
      [fetchRequirementsSuccessAction]: (state, action) => {
        return action.payload[field];
      },
    }
  );
};

const infestationLevels = requirementReducer('infestationLevels');
const infraTypes = requirementReducer('infraTypes');
const timeUnits = requirementReducer('timeUnits');
const contractTypes = requirementReducer('contractTypes');
const ratSpecies = requirementReducer('ratSpecies');
const insectSpecies = requirementReducer('insectSpecies');
const insectTreatments = requirementReducer('insectTreatments');
const otherSpecies = requirementReducer('otherSpecies');
const otherTreatments = requirementReducer('otherTreatments');
const annexConf = annexReducer('annexConf');
const annex1SimpleList1 = requirementReducer('annex1SimpleList1');
const annex1SimpleList2 = requirementReducer('annex1SimpleList2');
const annex1ComplexList = requirementReducer('annex1ComplexList');
const annex2SimpleList1 = requirementReducer('annex2SimpleList1');
const annex2SimpleList2 = requirementReducer('annex2SimpleList2');
const annex2ComplexList = requirementReducer('annex2ComplexList');
const placesRef = requirementReducer('placesRef');
const accessibilityRef = requirementReducer('accessibilityRef');

const isFetching = createReducer(false, {
  [fetchRequirementsAction]: (state, action) => {
    return true;
  },
  [fetchRequirementsSuccessAction]: (state, action) => {
    return false;
  },
});

const requirements = combineReducers({
  infestationLevels,
  infraTypes,
  timeUnits,
  contractTypes,
  ratSpecies,
  insectSpecies,
  insectTreatments,
  otherSpecies,
  otherTreatments,
  annexConf,
  isFetching,
  annex1SimpleList1,
  annex1SimpleList2,
  annex1ComplexList,
  annex2SimpleList1,
  annex2SimpleList2,
  annex2ComplexList,
  placesRef,
  accessibilityRef,
});

export default requirements;

export const getInfestationLevels = state =>
  state.requirements.infestationLevels;
export const getInfraTypes = state => state.requirements.infraTypes;
export const getTimeUnits = state => state.requirements.timeUnits;
export const getContractTypes = state => state.requirements.contractTypes;
export const getRatSpecies = state => state.requirements.ratSpecies;
export const getInsectSpecies = state => state.requirements.insectSpecies;
export const getInsectTreatments = state => state.requirements.insectTreatments;
export const getOtherSpecies = state => state.requirements.otherSpecies;
export const getOtherTreatments = state => state.requirements.otherTreatments;
export const getAnnexConf = state => state.requirements.annexConf;
export const getAnnex1SimpleList1 = state =>
  state.requirements.annex1SimpleList1;
export const getAnnex1SimpleList2 = state =>
  state.requirements.annex1SimpleList2;
export const getAnnex1ComplexList = state =>
  state.requirements.annex1ComplexList;
export const getAnnex2SimpleList1 = state =>
  state.requirements.annex2SimpleList1;
export const getAnnex2SimpleList2 = state =>
  state.requirements.annex2SimpleList2;
export const getAnnex2ComplexList = state =>
  state.requirements.annex2ComplexList;
export const getPlacesRef = state => state.requirements.placesRef;
export const getAccessibilityRef = state => state.requirements.accessibilityRef;



// WEBPACK FOOTER //
// ./src/modules/saas/pco/cases-creation/step2/reducers/requirements.js